module.exports = __webpack_public_path__ + "static/media/USDT.c643dbaa.svg";